var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacedock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#facedock_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.074 18.835h9.413c2.048 0 3.243-1.169 3.243-3.217v-1.53l3.49 2.893c.334.272.685.456 1.037.456.677 0 1.125-.492 1.125-1.239v-9.07c0-.747-.448-1.24-1.125-1.24-.352 0-.703.185-1.037.458l-3.49 2.891V7.708c0-2.048-1.195-3.208-3.243-3.208H5.074c-1.986 0-3.243 1.16-3.243 3.208v7.91c0 2.048 1.195 3.217 3.243 3.217zm.194-1.02c-1.52 0-2.347-.782-2.347-2.373V7.884c0-1.582.826-2.364 2.347-2.364h9.026c1.52 0 2.347.782 2.347 2.364v7.558c0 1.591-.826 2.373-2.347 2.373H5.268zm16.488-1.74l-4.026-3.27v-2.284l4.026-3.27c.132-.097.228-.167.343-.167.149 0 .237.114.237.316v8.535c0 .202-.088.316-.237.316-.115 0-.211-.08-.343-.176z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "facedock_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}

export default __webpack_public_path__ + "static/media/facedock.d615a00b.svg";
export { SvgFacedock as ReactComponent };